<template>
    <main class="flex items-center">
        <div>
            <tooltip :content="tooltip" position="bottom">
                <button
                    class="w-32 h-32 flex items-center justify-center cursor-pointer text-primary hover:text-secondary disabled:cursor-default disabled:text-primary-40"
                    :disabled="!announcements.length"
                    @click="show = true; markAnnouncementAsRead();"
                >
                    <svg-icon :type="icon" :size="iconSize"></svg-icon>
                </button>
            </tooltip>
        </div>
        <popout
            :show="show"
            :title="tooltip"
            @close="show = false; updateData();"
        >
            <ul class="w-480">
                <gimmick
                    v-for="announcement in announcements"
                    :key="'announcement-' + announcement.id"
                    :announcement="announcement"
                ></gimmick>
                <infinite-loading :slots="{complete: ' ', error: ' '}"
                                  @infinite="infiniteHandler">
                    <template #spinner>
                        <div class="p-16">
                            <loading size="small"></loading>
                        </div>
                    </template>
                </infinite-loading>
            </ul>
        </popout>
    </main>
</template>
<script>
import SvgIcon from './SvgIcon.vue';
import * as announcements from '../../services/AnnouncementService';
import Announcement from '../../models/Announcement';
import User from '../../models/User';
import InfiniteLoading from 'v3-infinite-loading/lib/v3-infinite-loading.es.js';
import Loading from './Loading.vue';
import Gimmick from './Gimmick.vue';
import Popout from './Popout.vue';
import Tooltip from '../navigation/Tooltip.vue';
import {useRepo} from "pinia-orm"
import {useMainStore} from "../../state/store";
import {mapStores} from "pinia";

export default {
    name: 'Gimmicks',
    components: {
        'svg-icon': SvgIcon,
        'tooltip': Tooltip,
        'infinite-loading': InfiniteLoading,
        'loading': Loading,
        'gimmick': Gimmick,
        'popout': Popout,
    },
    props: {
        icon: String,
        iconSize: {type: String, default: '16'},
        tooltip: String,
    },
    data: function () {
        return {
            show: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        announcements() {
            return useRepo(Announcement)
                .where('active', true)
                .with('announcement_tag')
                .orderBy('sequence', 'asc')
                .get();
        },
        currentUser() {
            return this.mainStore.currentUser;
        },
        announcementsCount() {
            return this.announcements.length;
        },
    },
    methods: {
        infiniteHandler(state) {
            return this.fetchAnnouncements(this.announcementsCount)
                .then(inserts => {
                    if (inserts.announcements && inserts.announcements.length) {
                        state.loaded();
                    } else {
                        state.complete();
                    }
                });
        },
        fetchAnnouncements(offset) {
            let limit = 4;

            return announcements.index({offset, limit})
                .then(result => {
                    return useRepo(Announcement).save(result);
                });
        },
        markAnnouncementAsRead() {
            announcements.markAnnouncementAsRead()
        },
        updateData() {
            return useRepo(User).save({id: this.currentUser.id, seen_last_announcement: 1});
        },

    },
    mounted() {
        this.fetchAnnouncements(0);
        /*this.$interval = setInterval(() => {
            this.fetchAnnouncements(0);
        }, 30000);*/
    },
    beforeUnmount() {
        if (this.$interval) {
            clearInterval(this.$interval);
        }
    },
};
</script>
<style scoped>
.pulsating {
    transform-origin: center;
    animation: pulsate 2s infinite;
}

@keyframes pulsate {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: scale(3);
    }
}

.pb-60 {
    padding-bottom: 60px;
}
</style>
